var React = require('react');

function IconGdrive (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#1D1E22","fillRule":"evenodd","d":"M28.17 14.72c0 7.95-5.44 13.6-13.48 13.6C6.99 28.33.76 22.1.76 14.4.76 6.7 6.98.46 14.69.46a13.4 13.4 0 019.34 3.65l-3.79 3.64C15.28 2.97 6.06 6.56 6.06 14.4c0 4.86 3.88 8.8 8.63 8.8 5.52 0 7.58-3.95 7.9-6h-7.9v-4.8h13.26c.13.72.22 1.4.22 2.33z","clipRule":"evenodd"}));
}

IconGdrive.defaultProps = {"fill":"none","viewBox":"0 0 29 29"};

module.exports = IconGdrive;

IconGdrive.default = IconGdrive;
